import React, { createContext, useContext, useEffect, useState } from "react";
import NumberPoolService from "../services/NumberPoolService";
import CustomerServices from "../services/CustomerService";
import DashboardService from "../services/DashboardService";
import { useUserToken } from "./UserTokenContext";
import { useToast } from "./ToastContext";
import { usePreLoaderContext } from "./PreloaderContext";
import asciiDecode from "../utils/crypto";
import { set } from "rsuite/esm/internals/utils/date";

const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
  const { userID, userToken, account, userLang, languageData } = useUserToken();
  const AICLanguage = languageData[userLang];
  const { showToast } = useToast();
  const { setPreLoaderVisible } = usePreLoaderContext();

  //data,nodata,loading
  const [uploadStatus, setUpploadStatus] = useState("nodata");
  // console.log("uploadStatus -->", uploadStatus);
  const [downloadUrl, setDownloadUrl] = useState("");
  // console.log("downloadUrl -->", downloadUrl);

  const [isPolling, setIsPolling] = useState(false);
  const [uploadPollingData, setUploadPollingData] = useState(null);
  // console.log("uploadPollingData -->", uploadPollingData);

  // const [totalCount, setTotalCount] = useState(0);
  // const [insertedCount, setInsertedCount] = useState(0);
  const [uploadProgress, setUploadProgress] = useState(0);
  // console.log("uploadProgress context -->", uploadProgress);
  // console.log("totalCount -->", totalCount);
  // console.log("insertedCount -->", insertedCount);

  const getReportService = (value) => {
    if (value === "customerService") return CustomerServices;
    if (value === "numberPoolService") return NumberPoolService;
  };

  async function uploadAllData(service, urlData) {
    try {
      setPreLoaderVisible(true);
      setUpploadStatus("loading");

      const response = await getReportService(service).insertMultiple(urlData);

      setPreLoaderVisible(false);
      showToast(
        {
          title: AICLanguage.preparing_file,
          text:
            response.data.Response.InsertId +
            " " +
            AICLanguage.your_file_is_being_prepared_you_can_track_the_download_status_from_the_status_bar_at_the_top_of_the_screen,
        },
        "warning-toast"
      );
      setIsPolling(true);
      setUploadPollingData({
        id: response.data.Response.InsertId,
        service: response.data.Response.Process,
      });

      return true;
    } catch (error) {
      setPreLoaderVisible(false);
      showToast(
        {
          title: AICLanguage.preparing_file,
          text: AICLanguage.the_file_could_not_be_downloaded_please_try_again,
        },
        "error-toast"
      );
      console.error(error);

      return false;
    }
  }

  const getDocument = async (data) => {
    try {
      const response = await DashboardService.insertLogInfo({
        accountcode: account.acc_accountcode,
        token: userToken,
        userid: userID,
        insertid: data.id,
        status: data.service,
      });

      // Veriyi kontrol et
      // console.log("Raw response:", response.data.Response.Data);

      if (response.data.Response.Status === "Success") {
        // Base64 içerik al

        // console.log("şifreli data -->", response);

        // const decryptReportData = asciiDecode(response.data.Response.Data);

        // console.log("decryptReportData -->", decryptReportData);

        // const base64Data = response.data.Response.FileData;
        // setDownloadUrl(decryptReportData.FileData);
        // setUpploadStatus("data");
        // console.log("response -->", response);
        if (
          response.data.Response.TotalCount ===
          response.data.Response.InsertedCount +
            response.data.Response.FailedCount
        ) {
          setIsPolling(false);
          setUploadPollingData(null);
          setUploadProgress(0);
          showToast(
            {
              title: AICLanguage.operation_completed,
              text: AICLanguage.your_file_has_been_uploaded_successfully,
            },
            "success-toast"
          );
        }
        if (
          response.data.Response.TotalCount >
          response.data.Response.InsertedCount
        ) {
          const completionRate =
            (response.data.Response.InsertedCount * 100) /
            response.data.Response.TotalCount;
          // console.log("yüzde -->", test);
          setUploadProgress(completionRate);
          // setUploadProgress(
          // (response.data.Response.InsertedCount * 100) /
          // response.data.Response.TotalCount)
          // setTotalCount(response.data.Response.TotalCount);
          // setInsertedCount(response.data.Response.InsertedCount);
        }

        // Dosya indir
        // downloadFile(decryptReportData);
      } else {
        console.error("Dosya oluşturulamadı.");
        showToast(
          {
            title: AICLanguage.preparing_file,
            text: AICLanguage.the_file_could_not_be_downloaded_please_try_again,
          },
          "error-toast"
        );
        setIsPolling(false);
      }
    } catch (error) {
      console.error("getDocument Hata:", error);
      setIsPolling(false);
    }
  };
  // const downloadFile = (base64Data) => {
  //   const link = document.createElement('a');  // Yeni bir <a> etiketi oluştur
  //   link.href = `data:application/octet-stream;base64,${base64Data}`;  // Base64 verisini URL olarak ayarla
  //   link.download = 'document.csv';  // Dosya ismini belirle
  //   document.body.appendChild(link);  // Linki body'e ekle
  //   link.click();  // Linke tıkla (bu, dosya indirilmeye başlayacak)
  //   document.body.removeChild(link);  // Linki body'den kaldır
  // };

  useEffect(() => {
    if (!isPolling || !uploadPollingData) return;

    const interval = setInterval(() => {
      getDocument(uploadPollingData);
    }, 10000);

    return () => clearInterval(interval);
  }, [isPolling, uploadPollingData]);

  const value = {
    uploadAllData,
    uploadProgress,
    // uploadStatus,
    // setUpploadStatus,
    // downloadUrl,
    // setDownloadUrl,
    // getDocument,
    uploadPollingData,
    isPolling,
    // setIsPolling,
    // setUploadPollingData,
  };

  return (
    <UploadContext.Provider value={value}>{children}</UploadContext.Provider>
  );
};

export const useUpload = () => useContext(UploadContext);
